import { Minus, Plus } from '@phosphor-icons/react';

/** Zahl mit −/+ (z. B. Raten 2–12, Anzahl Schlüssel). */
export interface StepperProps {
  wert: number;
  onChange: (wert: number) => void;
  min?: number;
  max?: number;
  schritt?: number;
  /** Einheit hinter der Zahl, z. B. „Raten“. */
  einheit?: string;
  label?: string;
}

export function Stepper({ wert, onChange, min = 0, max = Number.MAX_SAFE_INTEGER, schritt = 1, einheit, label }: StepperProps) {
  const setze = (v: number) => onChange(Math.min(max, Math.max(min, v)));
  const knopf = (aktiv: boolean) => ({
    width: 36, height: 36, borderRadius: '50%', border: 'none', display: 'flex', alignItems: 'center', justifyContent: 'center',
    background: 'var(--fill2)', color: 'var(--ink)', cursor: aktiv ? 'pointer' : 'not-allowed', opacity: aktiv ? 1 : 0.45,
  } as const);
  return (
    <div role="group" aria-label={label} className="inline-flex items-center" style={{ gap: 10, padding: 4, borderRadius: 22, background: 'var(--bg)', boxShadow: 'inset 0 0 0 1px var(--line)' }}>
      <button type="button" aria-label="Weniger" disabled={wert <= min} onClick={() => setze(wert - schritt)} style={knopf(wert > min)}>
        <Minus weight="bold" size={14} />
      </button>
      <span className="immo-zahl" aria-live="polite" style={{ minWidth: 40, textAlign: 'center', fontSize: 15, fontWeight: 800 }}>
        {wert}{einheit ? ` ${einheit}` : ''}
      </span>
      <button type="button" aria-label="Mehr" disabled={wert >= max} onClick={() => setze(wert + schritt)} style={knopf(wert < max)}>
        <Plus weight="bold" size={14} />
      </button>
    </div>
  );
}
